// The code in this file will load on every page of your site

$w.onReady(function () {
	
	$w("#xIcon").hide();

	$w("#searchIcon").onClick((event) => {
		$w("#userInput").show("slide", {direction: "right"});
		$w("#navBar").hide();
		$w("#dropdown1").hide();
		$w("#dropdown2").hide();
		$w("#searchIcon").hide();
		$w("#xIcon").show();
		});

	$w("#xIcon").onClick((event) => {
		$w("#userInput").hide("slide", {direction: "right"});
		$w("#navBar").show();
		$w("#dropdown1").show();
		$w("#dropdown2").show();
		$w("#xIcon").hide();
		$w("#searchIcon").show();
		});

});

$w.onReady(function () {

$w("#submenuContainer1").hide();
	$w("#submenuContainer2").hide();

 	$w("#productsButton").onClick(() => {
      if ($w("#submenuContainer1").hidden
	  ) {
    	  $w("#submenuContainer1").show();
		  $w("#bandanasPage").show();
		  $w("#collarsPage").show();
		  $w("#harnessesPage").show();
		  $w("#apparelPage").show();
		  $w("#stickersPage").show();
      } else {
            $w("#submenuContainer1").hide()
			$w("#bandanasPage").hide();
			$w("#collarsPage").hide();
			$w("#harnessesPage").hide();
			$w("#apparelPage").hide();
			$w("#stickersPage").hide();
        }
    });

	$w("#aboutButton").onClick(() => {
      if ($w("#submenuContainer2").hidden
	  ) {
    	  $w("#submenuContainer2").show();
		  $w("#aboutPage").show();
		  $w("#contactPage").show();
		
      } else {
            $w("#submenuContainer2").hide()
			$w("#aboutPage").hide();
			$w("#contactPage").hide();
        }
    })

	});